import { ServiceJourneyApiModel } from './service-journey.api-model';
import { StopPointApiModel } from './stop-point.api-model';

export class DepartureOrArrivalApiModelBase {
  public serviceJourney!: ServiceJourneyApiModel;
  public stopPoint!: StopPointApiModel;
  public plannedTime!: string;
  public estimatedTime?: string;
  public isCancelled!: boolean;
}
